import React from 'react';
import { ToastType } from '../types';
import {
  CheckCircleIcon,
  XCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';

export const getBackgroundColor = (type: ToastType): string => {
  switch (type) {
    case ToastType.SUCCESS:
      return 'bg-green-50';
    case ToastType.FAILURE:
      return 'bg-red-50';
    case ToastType.WARNING:
      return 'bg-yellow-50';
    case ToastType.INFO:
      return 'bg-blue-50';
  }
};

export const getTextColor = (type: ToastType): string => {
  switch (type) {
    case ToastType.SUCCESS:
      return 'text-green-800';
    case ToastType.FAILURE:
      return 'text-red-800';
    case ToastType.WARNING:
      return 'text-yellow-800';
    case ToastType.INFO:
      return 'text-blue-800';
  }
};

export const getProgressColorHex = (type: ToastType): string => {
  switch (type) {
    case ToastType.SUCCESS:
      return '#10B981';
    case ToastType.FAILURE:
      return '#EF4444';
    case ToastType.WARNING:
      return '#F59E0B';
    case ToastType.INFO:
      return '#3B82F6';
  }
};

export const getIcon = (type: ToastType) => {
  const className = 'w-5 h-5';
  const color = getProgressColorHex(type);

  switch (type) {
    case ToastType.SUCCESS:
      return <CheckCircleIcon className={className} style={{ color }} />;
    case ToastType.FAILURE:
      return <XCircleIcon className={className} style={{ color }} />;
    case ToastType.WARNING:
      return (
        <ExclamationTriangleIcon className={className} style={{ color }} />
      );
    case ToastType.INFO:
      return <InformationCircleIcon className={className} style={{ color }} />;
  }
};
